/*
  This code defines a JavaScript module responsible for managing a cart drawer on a webpage. It includes functions for initializing the drawer, loading its template, opening and closing the drawer, and updating the cart data before opening the drawer. 

  - cartDrawer(): A function that returns an object representing the cart drawer module. It contains methods:
    - init(): Initializes the cart drawer by loading its template.
    - loadTemplate(): Loads the template for the cart drawer from a specified HTML element and replaces the content of the root element with the loaded template. 
    - openCart(): Opens the cart drawer by showing its modal dialog.
    - closeCart(): Closes the cart drawer by invoking a method to close any open drawers.
    - updateAndOpenCart({ detail }): Asynchronously updates the cart data and then opens the cart drawer, optionally skipping the opening step if specified in the event detail.

  The module is then registered with Alpine.js to be used in the HTML as a component.
*/

const cartDrawer = () => ({
  init() {
    this.loadTemplate();
  },

  loadTemplate() {
    const content = document.querySelector('.js-cart-template').content.cloneNode(true);
    content.querySelector('.cart').classList.add('cart--drawer');
    this.$root.replaceChildren(content);
  },

  openCart() {
    this.$root.closest('dialog').showModal();
  },

  closeCart() {
    this.closeOpenDrawers();
  },

  async updateAndOpenCart({ detail }) {
    await this.$store.cart.fetchCart();

    if (detail?.noOpenAfterUpdate) {
      return;
    }

    this.$root.closest('dialog').showModal();
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('cartDrawer', cartDrawer);
});
